import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "nerosun_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const login = (password) =>
  api.post("/auth/login", { password }).then((r) => r.data);
export const verifyAuth = () => api.get("/auth/me").then((r) => r.data);

export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchArticles = (params = {}) =>
  api.get("/articles", { params }).then((r) => r.data);
export const fetchArticle = (slug) =>
  api.get(`/articles/${slug}`).then((r) => r.data);
export const fetchArtists = (sortBy = "overall") =>
  api.get("/artists", { params: { sort_by: sortBy } }).then((r) => r.data);
export const fetchArtist = (slug) =>
  api.get(`/artists/${slug}`).then((r) => r.data);
export const generateArticle = (topic, category) =>
  api.post("/ai/generate-article", { topic, category }).then((r) => r.data);
export const generateBatch = (topics, category) =>
  api.post("/ai/generate-batch", { topics, category }).then((r) => r.data);
export const createArticle = (payload) =>
  api.post("/articles", payload).then((r) => r.data);
export const deleteArticle = (id) =>
  api.delete(`/articles/${id}`).then((r) => r.data);

export const createArtist = (payload) =>
  api.post("/artists", payload).then((r) => r.data);
export const updateArtist = (id, payload) =>
  api.put(`/artists/${id}`, payload).then((r) => r.data);
export const deleteArtist = (id) =>
  api.delete(`/artists/${id}`).then((r) => r.data);
export const fetchRankingsMeta = () => api.get("/rankings/meta").then((r) => r.data);
export const fetchRankingsSyncStatus = () =>
  api.get("/admin/rankings/sync-status").then((r) => r.data);
export const triggerRankingsSync = () =>
  api.post("/admin/rankings/sync").then((r) => r.data);
export const fetchRankingSuggestions = () =>
  api.get("/admin/rankings/suggestions").then((r) => r.data);
export const approveSuggestion = (id) =>
  api.post(`/admin/rankings/suggestions/${id}/approve`).then((r) => r.data);
export const approveAllSuggestions = () =>
  api.post("/admin/rankings/suggestions/approve-all").then((r) => r.data);
export const dismissSuggestion = (id) =>
  api.post(`/admin/rankings/suggestions/${id}/dismiss`).then((r) => r.data);
export const removeUnrankedArtists = () =>
  api.delete("/admin/rankings/unranked").then((r) => r.data);
export const fetchArtistHistory = (slug) =>
  api.get(`/artists/${slug}/history`).then((r) => r.data);
export const fetchAdminArticles = () =>
  api.get("/admin/articles").then((r) => r.data);
export const publishDraft = (id) =>
  api.post(`/articles/${id}/publish`).then((r) => r.data);
export const createMoversDraft = () =>
  api.post("/admin/rankings/movers-draft").then((r) => r.data);

export const fetchAdvertorials = () =>
  api.get("/advertorials").then((r) => r.data);
export const fetchAdvertorial = (slug) =>
  api.get(`/advertorials/${slug}`).then((r) => r.data);
export const generateAdvertorial = (brand, product, angle, category) =>
  api.post("/ai/generate-advertorial", { brand, product, angle, category }).then((r) => r.data);
export const createAdvertorial = (payload) =>
  api.post("/advertorials", payload).then((r) => r.data);

export const createAdInquiry = (payload) =>
  api.post("/ad-inquiries", payload).then((r) => r.data);
export const createContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const fetchVideos = () => api.get("/videos").then((r) => r.data);
export const createVideo = (payload) =>
  api.post("/videos", payload).then((r) => r.data);
export const deleteVideo = (id) =>
  api.delete(`/videos/${id}`).then((r) => r.data);
export const fetchAdInquiries = () =>
  api.get("/ad-inquiries").then((r) => r.data);
export const updateAdInquiry = (id, status) =>
  api.patch(`/ad-inquiries/${id}`, { status }).then((r) => r.data);
export const fetchRankingStatus = () =>
  api.get("/admin/ranking-status").then((r) => r.data);
export const markRankingReviewed = () =>
  api.post("/admin/ranking-reviewed").then((r) => r.data);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const createCommunitySubmission = (payload) =>
  api.post("/community-submissions", payload).then((r) => r.data);
export const fetchCommunitySubmissions = () =>
  api.get("/community-submissions").then((r) => r.data);
export const updateCommunitySubmission = (id, status) =>
  api.patch(`/community-submissions/${id}`, { status }).then((r) => r.data);

export const fetchHouseAds = (placement) =>
  api.get("/house-ads", { params: placement ? { placement } : {} }).then((r) => r.data);
export const manageHouseAds = () =>
  api.get("/house-ads/manage").then((r) => r.data);
export const createHouseAd = (payload) =>
  api.post("/house-ads", payload).then((r) => r.data);
export const updateHouseAd = (id, active) =>
  api.patch(`/house-ads/${id}`, { active }).then((r) => r.data);
export const deleteHouseAd = (id) =>
  api.delete(`/house-ads/${id}`).then((r) => r.data);

// Resolve a stored image path (e.g. /api/images/xxx) to an absolute URL
export const mediaUrl = (path) =>
  !path ? path : path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
